module.exports = __webpack_public_path__ + "static/img/3.73d70f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/3.png
// module id = ZvBq
// module chunks = 0